import moment from "moment";
import "moment/locale/tr";

import { getProjectType } from "src/utils/constants/project-detail";

const convertToPercent = (numberValue) => `%${Math.round(numberValue * 100)}`;

const formatHousingTypes = (roomCount) => {
  if (!roomCount?.length) return null;

  return roomCount.length > 5
    ? [...roomCount.slice(0, 3).map(({ name }) => name), "...", ...roomCount.slice(-2).map(({ name }) => name)].join(
        ", "
      )
    : roomCount.map(({ name }) => name).join(", ");
};

const createProjectDescriptions = ({
  locationInfo,
  projectType,
  residenceType,
  isImmediateDelivery,
  date,
  roomCount,
  unitCount,
  percentageOfDelivery,
  percentageOfSale,
}) => {
  const descriptions = [
    locationInfo?.district?.name && locationInfo?.city?.name
      ? [`location`, `${locationInfo.city.name}, ${locationInfo.district.name}`]
      : null,

    projectType?.length
      ? [
          "projectType",
          projectType.map(getProjectType).join(", ") +
            (residenceType?.length
              ? " | " +
                residenceType
                  .map(getProjectType)
                  .filter(Boolean)
                  .map((type) => (type === "İş Yeri" ? "Ofis" : type))
                  .join(", ")
              : ""),
        ]
      : null,

    isImmediateDelivery !== undefined
      ? [
          `deliveryDate`,
          isImmediateDelivery ? "Hemen Teslim" : date ? `${moment(date).format("MMMM YYYY")}` : undefined,
        ]
      : null,

    roomCount?.length ? ["housingTypes", formatHousingTypes(roomCount)] : null,
    unitCount ? [`housingCount`, `${new Intl.NumberFormat("tr-TR").format(unitCount)} Konut`] : null,
    percentageOfDelivery ? [`completionPercentage`, `${convertToPercent(percentageOfDelivery)} Tamamlandı`] : null,
    percentageOfSale ? [`salesPercentage`, `${convertToPercent(percentageOfSale)} Satıldı`] : null,
  ].filter(Boolean);

  return Object.fromEntries(descriptions);
};

export { createProjectDescriptions };
